// file: src/pages/landing/components/WelcomeSection.jsx
import React from 'react';
import SearchBar from '../../../components/common/SearchBar';
import QuickActions from './QuickActions';
import styles from './WelcomeSection.module.css';

/**
 * WelcomeSection component displays the hero section with search and quick actions
 * @param {Array} projects - Array of project objects for search
 * @param {Function} onProjectSelect - Callback when a project is selected from search
 * @param {Function} onFileSelect - Callback when a file is selected from search
 * @param {Function} onCreateProject - Callback when "New Project" is clicked
 * @param {Function} onManageServers - Callback when "Manage Servers" is clicked
 * @param {Function} onManageFiles - Callback when "Manage Files" is clicked
 */
function WelcomeSection({ 
  projects, 
  onProjectSelect, 
  onFileSelect,
  onCreateProject,
  onManageServers,
  onManageFiles
}) {
  return (
    <div className={styles.welcomeSection}>
      <div className={styles.welcomeContainer}>
        {/* Welcome message */}
        <div className="mb-8">
          <h1 className={styles.welcomeTitle}>
            What will you <span className={styles.welcomeTitleHighlight}>build</span> today?
          </h1>
        </div>

        {/* Search bar */}
        <div className={styles.searchContainer}>
          <SearchBar 
            projects={projects}
            onProjectSelect={onProjectSelect}
            onFileOpen={onFileSelect}
            size="large"
            placeholder="Search projects and files..."
          />
        </div>

        {/* Quick action buttons */}
        <QuickActions
          onCreateProject={onCreateProject}
          onManageServers={onManageServers}
          onManageFiles={onManageFiles}
        />
      </div>
    </div>
  );
}

export default WelcomeSection;
